export enum SectionId {
  Manual = 'manual',
  Smart = 'smart',
  Calculator = 'calculator',
}
